import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DocumentPreviewService {
  constructor(private router: Router) { }

  preview(file: string, fileName?: string, sourcePageTitle: string = 'Documents'): Promise<boolean> {
    if (!file || !file.trim()) {
      return Promise.resolve(false);
    }

    return this.router.navigate(['/preview'], {
      state: {
        file,
        fileName: fileName || this.getFileName(file),
        sourcePageTitle
      }
    });
  }

  private getFileName(file: string): string {
    const path = file.split(/[?#]/, 1)[0];
    const name = path.substring(path.lastIndexOf('/') + 1);
    try {
      return decodeURIComponent(name);
    } catch (error) {
      return name;
    }
  }
}